export default "__VITE_ASSET__B4ZyY87v__"